"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _conjugated_verb_string = _interopRequireDefault(require("./conjugated_verb_string"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _constants = require("@seedlang/constants");
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var RootWord = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(function (item) {
  return item;
}, function (item) {
  return item;
})), _dec2 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_conjugated_verb_string["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function RootWord() {
    var _this;
    _classCallCheck(this, RootWord);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RootWord, [].concat(args));
    _initializerDefineProperty(_this, "meanings", _descriptor, _this);
    _initializerDefineProperty(_this, "id", _descriptor2, _this);
    _initializerDefineProperty(_this, "sentencesCount", _descriptor3, _this);
    _initializerDefineProperty(_this, "targetText", _descriptor4, _this);
    _initializerDefineProperty(_this, "targetId", _descriptor5, _this);
    _initializerDefineProperty(_this, "gender", _descriptor6, _this);
    _initializerDefineProperty(_this, "plural", _descriptor7, _this);
    _initializerDefineProperty(_this, "useParenthesesOnGender", _descriptor8, _this);
    _initializerDefineProperty(_this, "articleHasApostrophe", _descriptor9, _this);
    _initializerDefineProperty(_this, "articleTakesOppositeGender", _descriptor0, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor1, _this);
    _initializerDefineProperty(_this, "articleIsHidden", _descriptor10, _this);
    _initializerDefineProperty(_this, "singularArticle", _descriptor11, _this);
    _initializerDefineProperty(_this, "pluralArticle", _descriptor12, _this);
    _initializerDefineProperty(_this, "conjugatedVerbStrings", _descriptor13, _this);
    return _this;
  }
  _inherits(RootWord, _RootModel);
  return _createClass(RootWord, [{
    key: "definiteArticle",
    get: function get() {
      if ((0, _utils.isPresent)(this.gender)) {
        var article = this.plural ? this.pluralArticle : this.singularArticle;
        if (this.useParenthesesOnGender) {
          article = "(".concat(article, ")");
        }
        return article;
      }
      return null;
    }
  }, {
    key: "genderAbbreviation",
    get: function get() {
      var gender = '';
      if (this.gender === 'feminine') {
        gender = ' (f.)';
      } else if (this.gender === 'masculine' && this.languageId === 'NL') {
        gender = ' (c.)';
      } else if (this.gender === 'masculine') {
        gender = ' (m.)';
      } else if (this.gender === 'neuter') {
        gender = ' (n.)';
      }
      return gender;
    }
  }, {
    key: "targetTextWithDefiniteArticle",
    get: function get() {
      // also in translation_basic.js, word.js
      if (this.articleIsHidden) {
        return this.targetText;
      }
      if (this.isNoun && this.languageId === 'DE' && this.gender && !this.root && this.caseAbbreviation && !this.plural && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()] && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()][this.gender]) {
        return "".concat(_constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()][this.gender], " ").concat(this.targetText);
      }
      if (this.isNoun && this.languageId === 'DE' && this.gender && !this.root && this.caseAbbreviation && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()] && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()].plural) {
        return "".concat(_constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()].plural, " ").concat(this.targetText);
      } else if (this.languageId === 'IT' && this.isNoun && this.gender === 'masculine' && "".concat(_constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR, "szSZ").includes(this.targetText[0])) {
        if (this.plural) {
          return "gli ".concat(this.targetText);
        } else {
          return "lo ".concat(this.targetText);
        }
      } else if (this.languageId === 'CA' && this.isNoun && !this.plural && this.gender) {
        // Catalan specific logic: feminine words beginning with unstressed I, HI, U or HU should NOT take apostrophe
        if (this.articleHasApostrophe || this.shouldTakeApostropheInCatalan() && !this.feminineWordWithNoApostropheInCatalan()) {
          return "l'".concat(this.targetText).concat(this.genderAbbreviation);
        } else {
          return "".concat(this.definiteArticle, " ").concat(this.targetText).concat(this.articleTakesOppositeGender ? this.genderAbbreviation : '');
        }
      } else if (this.isNoun && !this.plural && this.gender && ['FR', 'IT'].includes(this.languageId) && (this.articleHasApostrophe || _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR.includes(this.targetText[0]))) {
        return "l'".concat(this.targetText).concat(this.languageId !== 'IT' ? this.genderAbbreviation : '');
      } else if (this.isNoun && this.gender && this.definiteArticle) {
        return "".concat(this.definiteArticle, " ").concat(this.targetText).concat(this.articleTakesOppositeGender ? this.genderAbbreviation : '');
      }
      return this.targetText;
    }
  }, {
    key: "shouldTakeApostropheInCatalan",
    value: function shouldTakeApostropheInCatalan() {
      // Most words beginning with a vowel take an apostrophe in Catalan
      return _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_CA.includes(this.targetText[0]);
    }
  }, {
    key: "feminineWordWithNoApostropheInCatalan",
    value: function feminineWordWithNoApostropheInCatalan() {
      // Feminine words beginning with unstressed I, HI, U or HU should NOT take apostrophe
      return this.gender === 'feminine' && /^[iu]|^hi|^hu/i.test(this.targetText);
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "meanings", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sentencesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "targetText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "targetId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "gender", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "plural", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "useParenthesesOnGender", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "articleHasApostrophe", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "articleTakesOppositeGender", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "articleIsHidden", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "singularArticle", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "pluralArticle", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "conjugatedVerbStrings", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "definiteArticle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "definiteArticle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderAbbreviation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderAbbreviation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetTextWithDefiniteArticle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetTextWithDefiniteArticle"), _class.prototype), _class);
var _default = exports["default"] = RootWord;